module.exports = __webpack_public_path__ + "static/media/loading.584b607f.gif";